import React from 'react';

import { BookingContext, BookingErrorCode } from '@app/components/Pages/Booking/Booking';
import EndSessionScreen from '@app/components/UI/Booking/ErrorCode/EndSessionScreen';
import FamilyDidNotReceiveCode from '@app/components/UI/Booking/ErrorCode/FamilyDidNotReceiveCode';
import IgnoredForAllVetsPetType from '@app/components/UI/Booking/ErrorCode/IgnoredForAllVetsPetType';
import InvalidFamily from '@app/components/UI/Booking/ErrorCode/InvalidFamily';
import LargePet from '@app/components/UI/Booking/ErrorCode/LargePet';
import MultipleFamilyMatches from '@app/components/UI/Booking/ErrorCode/MultipleFamilyMatches';
import NotAvailable from '@app/components/UI/Booking/ErrorCode/NotAvailable';
import PetRequiresAttention from '@app/components/UI/Booking/ErrorCode/PetRequiresAttention';
import RequestCallErrorScreen from '@app/components/UI/Booking/ErrorCode/RequestCallErrorScreen';
import RestrictedLocation from '@app/components/UI/Booking/ErrorCode/RestrictedLocation';
import UnableToConfirm from '@app/components/UI/Booking/ErrorCode/UnableToConfirm';
import useOnlineBookingErrorTracking from '@app/hooks/useOnlineBookingErrorTracking';

const BookingErrorScreen: React.FC = () => {
	const [errorScreen, setErrorScreen] = React.useState<React.ReactNode>(null);

	const context = React.useContext(BookingContext);

	if (!context?.state) throw new Error('Error context');

	const {
		state: { item, errorCode },
		action: { setErrorCode },
	} = context;

	React.useEffect(() => {
		switch (errorCode) {
			case BookingErrorCode.UnableToConfirm:
				setErrorScreen(<UnableToConfirm />);
				break;
			case BookingErrorCode.RestrictedLocation:
				setErrorScreen(<RestrictedLocation />);
				break;
			case BookingErrorCode.InvalidSession:
				setErrorScreen(<EndSessionScreen
					text={(<p>
						Your booking session has expired. Please start over to complete your booking.
					</p>)}
				/>);
				break;
			case BookingErrorCode.MultipleFamilyMatches:
				setErrorScreen(<MultipleFamilyMatches />);
				break;
			case BookingErrorCode.DidNotReceiveCode:
				setErrorScreen(<FamilyDidNotReceiveCode />);
				break;
			case BookingErrorCode.NotAvailable:
				setErrorScreen(<NotAvailable onClick={() => setErrorCode(null)} />);
				break;
			case BookingErrorCode.PetRequiresAttention:
				setErrorScreen(<PetRequiresAttention title={`${item?.petName.trim() || 'Pet'}'s Information`} />);
				break;
			case BookingErrorCode.LargePet:
				setErrorScreen(<LargePet title={`${item?.petName.trim() || 'Pet'}'s Information`} />);
				break;
			case BookingErrorCode.InvalidFamily:
				setErrorScreen(<InvalidFamily />);
				break;
			case BookingErrorCode.NoAvailableAssistance:
				setErrorScreen(<LargePet title="Final Arrangements" />);
				break;
			case BookingErrorCode.IgnoredForAllVetsPetType:
				setErrorScreen(<IgnoredForAllVetsPetType />);
				break;
			case BookingErrorCode.RequestCallBack:
				setErrorScreen(<RequestCallErrorScreen />);
				break;
			default:
				setErrorScreen(<EndSessionScreen text={<p>Service unavailable. Please try again later.</p>} />);
				break;
		}
	}, []);

	useOnlineBookingErrorTracking();

	return (
		<div className="online-booking">
			<div className="container bg-white">
				{errorScreen}
			</div>
		</div>
	);
};

export default BookingErrorScreen;
